import { formatDisplayAmount, formatDisplayNumber, formatDisplayDate, formatDisplayDateTime } from "./displayFormat.mjs";
export const toNumber = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const normalizeText = (value) => String(value || "").trim();

const formatDateTimeValue = (value) => {
  const normalized = normalizeText(value);
  if (!normalized) return "-";
  const parsed = new Date(normalized.replace(" ", "T"));
  if (Number.isNaN(parsed.getTime())) return normalized;
  return formatDisplayDateTime(parsed);
};

export const formatNumber = function formatNumber(value) {
  return formatDisplayNumber(toNumber(value, 0));
};

export const formatCurrency = function formatCurrency(value) {
  const parsed = toNumber(value, null);
  if (parsed === null) return "-";
  return formatDisplayAmount(parsed);
};

export const formatDate = function formatDate(value) {
  const normalized = normalizeText(value);
  if (!normalized) return "-";
  const parsed = new Date(`${normalized}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) return normalized;
  return formatDisplayDate(parsed);
};

export const formatDateTime = function formatDateTime(value) {
  return formatDateTimeValue(value);
};

export const parseDateToMs = function parseDateToMs(value) {
  const normalized = normalizeText(value);
  if (!normalized) return null;
  const parsed = new Date(normalized.replace(" ", "T"));
  if (Number.isNaN(parsed.getTime())) return null;
  return parsed.getTime();
};

export const isNextActivityOverdue = function isNextActivityOverdue(value) {
  const dueAtMs = parseDateToMs.call(this, value);
  if (dueAtMs === null) return false;
  return dueAtMs < Date.now();
};

export const statusLabel = function statusLabel(status) {
  const normalized = normalizeText(status).toLowerCase();
  if (!normalized) return "-";
  const i18nKey = `ncrm.deals.statuses.${normalized}`;
  const translated = this.$t(i18nKey);
  return translated === i18nKey ? normalized : translated;
};

export const statusColor = function statusColor(status) {
  const normalized = normalizeText(status).toLowerCase();
  if (normalized === "won") return "success";
  if (normalized === "lost") return "error";
  return "primary";
};

export const activityTypeShortLabel = function activityTypeShortLabel(activityType) {
  const normalized = normalizeText(activityType).toLowerCase();
  if (!normalized) return "";
  const i18nKey = `ncrm.activity.types.${normalized}`;
  if (typeof this.$te === "function" && this.$te(i18nKey)) {
    return normalizeText(this.$t(i18nKey));
  }
  const fallbackMap = {
    todo: "To do",
    call: "Call",
    email: "Email",
    meeting: "Meeting",
    note: "Note",
  };
  return fallbackMap[normalized] || normalized;
};

export const shortenInlineCardValue = function shortenInlineCardValue(value, maxLength = 22) {
  const normalized = normalizeText(value);
  if (!normalized) return "";
  if (normalized.length <= maxLength) return normalized;
  return `${normalized.slice(0, Math.max(1, maxLength - 3)).trimEnd()}...`;
};

export const nextActivityInlineLabel = function nextActivityInlineLabel(deal = {}) {
  const dueLabel = formatDateTimeValue(deal?.next_activity_due_at);
  const dueSafe = dueLabel && dueLabel !== "-" ? dueLabel : "";
  const titleSafe = shortenInlineCardValue.call(this, deal?.next_activity_title, 22);
  const typeSafe = activityTypeShortLabel.call(this, deal?.next_activity_type);
  const namePart = titleSafe || typeSafe;
  if (namePart && dueSafe) return `${namePart} • ${dueSafe}`;
  if (namePart) return namePart;
  if (dueSafe) return dueSafe;
  return "-";
};

// Coloanele view-ului tabel al board-ului de deals (extras din NcrmDealBoard.vue,
// fisier peste pragul de dimensiune). `last_call` este celula „Ultimul apel".
export const buildDealBoardTableHeaders = (t) => [
  { title: t("ncrm.deals.board.table.name"), key: "name" },
  { title: t("ncrm.deals.board.table.company"), key: "company_name" },
  { title: t("ncrm.activity.lastCall.header"), key: "last_call", sortable: false },
  { title: t("ncrm.deals.board.table.stage"), key: "stage_name" },
  { title: t("ncrm.deals.board.table.status"), key: "status" },
  { title: t("ncrm.deals.board.table.owner"), key: "owner_name" },
  { title: t("ncrm.deals.board.table.value"), key: "expected_value", align: "end" },
  { title: t("ncrm.deals.board.table.expectedCloseDate"), key: "expected_close_date" },
  { title: t("ncrm.deals.board.table.updatedAt"), key: "updated_at", sortable: true },
  { title: "", key: "row_nav", sortable: false, width: "48px", align: "center" },
];
